/* eslint-disable react/button-has-type */
import React from 'react';
import cx from 'classnames';
import { useTrackingContext } from '../../shared/TrackingContext';
import styles from './Button.module.scss';
import ButtonProps from './Button.types';
import Spinner from '../Spinner';

const Button = ({
  children,
  onClick,
  variant = 'contained',
  color = 'primary',
  disabled = false,
  isLoading = false,
  type = 'button',
  className = '',
  isFullWidth = false,
  dataCy = 'button',
  dataModalClose,
  trackingLabel = null,
  bold = true,
  maxWidth,
  ...rest
}: ButtonProps) => {
  const { track } = useTrackingContext();

  const classes = cx(
    styles[variant],
    {
      [styles.btnRegular]: !bold,
      [styles.btnLoading]: isLoading,
      [styles[color]]: !isLoading,
      [styles.fullWidth]: isFullWidth,
      [styles.disabled]: disabled,
    },
    className,
  );

  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (trackingLabel) {
      track('Button Click', { trackingLabel });
    }

    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      onClick={handleButtonClick}
      type={type}
      className={classes}
      disabled={disabled || isLoading}
      data-cy={dataCy}
      data-modalclose={dataModalClose}
      style={maxWidth && { maxWidth: `${maxWidth}rem` }}
      {...rest}>
      {isLoading ? (
        <div className={styles.spinnerWrapper}>
          <Spinner />
          <wbr />
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
